import { ITimeZone } from '../types/ITimeZone';
import { Request } from './Request';

export interface IGetUserSelectableTimeZonesParams {
}

export interface IGetUserSelectableTimeZonesResult {
    extraTimeZonesList: ITimeZone[];
    curatedTimeZonesList: ITimeZone[];
    serverTimeZone: ITimeZone;
}

export class GetUserSelectableTimeZonesRequest extends Request<IGetUserSelectableTimeZonesParams, IGetUserSelectableTimeZonesResult> {
    constructor(params: IGetUserSelectableTimeZonesParams = {}) {
        super('getUserSelectableTimeZones', params);
    }
}
